/**
 * Pixel glyph (§4.9): a 16×16 bitmap from `pixelIcons.ts`, drawn in `currentColor` with crisp
 * edges. Always `aria-hidden`; the accessible name comes from the surrounding control.
 */
import { pixelIconPath, PIXEL_ICONS, type PixelIconName } from '../game/assets/pixelIcons';

const PATHS = new Map<PixelIconName, string>();

export function PixelIcon({
  name,
  size = 24,
  className,
}: {
  name: PixelIconName;
  /** CSS px; multiples of 16 (16, 24 at 1.5×, 32) stay pixel-crisp on 2–3× screens. */
  size?: number;
  className?: string;
}) {
  let d = PATHS.get(name);
  if (!d) {
    d = pixelIconPath(PIXEL_ICONS[name]);
    PATHS.set(name, d);
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      shapeRendering="crispEdges"
      fill="currentColor"
      className={className}
      aria-hidden="true"
      focusable="false"
      data-pixel-icon={name}
    >
      <path d={d} />
    </svg>
  );
}
